import { object, string } from 'yup';

export const formValidation = object({
    userName: string().required("Por favor, preencha o utilizador/email."),
    password: string().required("Por favor, preencha a senha.")
});